module.exports = __webpack_public_path__ + "distribution/img/hader_top.72b75f61.png";